export default context => ({
  redirect: `/${context.params.notShit}`,
});
